import { Injectable, Inject} from '@angular/core';

export class PolicyPremiumSummaryDO {

	private  id:Number;

	public  getId():Number {
		return this.id;
	}
}